import { useToast } from '@monorepo/shared/contexts/ToastContext';
import { useAnalyticsSyncDelete } from '@monorepo/shared/hooks/analyticsSync/useAnalyticsSyncDelete';
import { useModal } from '@monorepo/shared/hooks/useModalV2';
import { useCallback } from 'react';

export const useHandleStopSync = (datasetOriginLabel: string) => {
  const { confirm } = useModal();
  const [deleter] = useAnalyticsSyncDelete({ config: { throwOnError: true } });
  const { success: showSuccessToast, showUserFriendlyErrorToast } = useToast();
  const handleStopSync = useCallback(
    async (datasetId: string, organizationId: string) => {
      try {
        const isConfirmed = await confirm({
          title: `Stop Syncing to Analytics`,
          description: `Are you sure you want to stop syncing ${datasetOriginLabel} to analytics? Restrictions on updates to upstream data will be lifted, but any data model in Sigma that uses this ${datasetOriginLabel} will stop getting any updates. Once you activate Analytics sync again, you will have to copy the new SQL since all the keys might change.`,
          cancelButtonText: 'Keep syncing',
          confirmButtonText: 'Stop syncing',
          danger: true,
          onConfirmAsync: async () => {
            await deleter({
              inputDatasetId: datasetId,
              organizationId,
            });
          },
          afterConfirmButtonText: 'Stopping sync...',
        });
        if (isConfirmed) {
          showSuccessToast(
            `${datasetOriginLabel} is no longer syncing to analytics.`,
          );
        }
      } catch (err) {
        showUserFriendlyErrorToast(err, 'Unable to stop syncing');
      }
    },
    [
      confirm,
      deleter,
      showSuccessToast,
      showUserFriendlyErrorToast,
      datasetOriginLabel,
    ],
  );
  return handleStopSync;
};
